module.exports = __webpack_public_path__ + "static/media/机场.57b9aa29.svg";